/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_List_Registry_Need_RuianInputs */

const cs_property_list_registry_need_ruian = /** @type {(inputs: Property_List_Registry_Need_RuianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`U této nemovitosti ještě není kód RÚIAN. Otevřete ji a nastavte adresu.`)
};

const en_property_list_registry_need_ruian = /** @type {(inputs: Property_List_Registry_Need_RuianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This listing has no RÚIAN code yet. Open the property and set the address first.`)
};

/**
* | output |
* | --- |
* | "This listing has no RÚIAN code yet. Open the property and set the address first." |
*
* @param {Property_List_Registry_Need_RuianInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_list_registry_need_ruian = /** @type {((inputs?: Property_List_Registry_Need_RuianInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_List_Registry_Need_RuianInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_list_registry_need_ruian(inputs)
	return cs_property_list_registry_need_ruian(inputs)
});